import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { motion, useAnimate } from "framer-motion";
import { MOBILE } from "../../constants/breakpoints";

let Edited = () => {
  let PathVariants = {
    start: {
      d: "M 1246.697 -42.712 C 1246.697 43.601 1182.131 114.018 1101.975 114.018 C 1021.818 114.018 957.252 43.601 957.252 -42.712 C 957.252 -129.025 1021.818 -199.441 1101.975 -199.441 C 1182.131 -199.441 1246.697 -129.025 1246.697 -42.712 Z",
    },
    mid: {
      d: "M 1441.305 51.9 C 1441.305 276.512 1224.957 438.248 1018.303 438.248 C 811.651 438.248 713.779 254.144 713.779 29.533 C 713.779 -195.079 877.521 -194.834 1084.174 -194.834 C 1290.827 -194.834 1441.305 -172.712 1441.305 51.9 Z",
    },
    final: {
      d: "M 1246.697 -42.712 C 1246.697 43.601 1182.131 114.018 1101.975 114.018 C 1021.818 114.018 957.252 43.601 957.252 -42.712 C 957.252 -129.025 1021.818 -199.441 1101.975 -199.441 C 1182.131 -199.441 1246.697 -129.025 1246.697 -42.712 Z",
    },
  };
  let circle1Varients = {
    start: { cx: 737.173, cy: 76.173, r: 76.173 },
    mid: { cx: 509.173, cy: 76.173, r: 76.173 },
    final: { cx: 737.173, cy: 76.173, r: 76.173 },
  };
  let circle2Varients = {
    start: { cx: 887.576, cy: 283.353, r: 102.445 },
    mid: { cx: 906.297, cy: 291.683, r: 102.445 },
    final: { cx: 887.576, cy: 283.353, r: 102.445 },
  };
  let circle3Varients = {
    start: {
      cx: 1238.16,
      cy: 227.198,
      r: 63.7318,
      transform: "rotate(95.7089 1238.16 227.198)",
    },
    mid: {
      cx: 1238.16,
      cy: 227.198,
      r: 63.732,
      transform:
        "matrix(-0.076773, 0.767956, -1.430653, -0.143023, 1797.303101, -849.275879)",
    },
    final: {
      cx: 1238.16,
      cy: 227.198,
      r: 63.7318,
      transform: "rotate(95.7089 1238.16 227.198)",
    },
  };
  //create vareints for all remaining circles
  let circle4Varients = {
    start: {
      cx: 1096.95,
      cy: -32.0508,
      r: 317.24,
    },
    mid: {
      cx: 600,
      cy: -32.051,
      r: 357.747,
    },
    final: {
      cx: 1096.95,
      cy: -32.0508,
      r: 317.24,
    },
  };
  let circle5Varients = {
    start: {
      cx: 1225.48,
      cy: 164.165,
      r: 63.7318,
      transform: "rotate(95.7089 1225.48 164.165)",
    },
    mid: {
      cx: 1225.48,
      cy: 164.165,
      r: 63.732,
      transform:
        "matrix(-0.099474, 0.99504, -0.99504, -0.099474, 1375.454025, -1014.865183)",
    },
    final: {
      cx: 1225.48,
      cy: 164.165,
      r: 63.7318,
      transform: "rotate(95.7089 1225.48 164.165)",
    },
  };

  const [animateVarient, setanimateVarient] = useState("start");
  useEffect(() => {
    setTimeout(() => {
      if (animateVarient == "start") {
        setanimateVarient("mid");
      } else {
        setanimateVarient("start");
      }
    }, 1000);
  }, [animateVarient]);

  return (
    <svg
      width="1440"
      height="900"
      viewBox="0 0 1440 900"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2755_7146)">
        <rect
          width="1440"
          height="900"
          fill="white"
          css={css`
            pointer-events: none;
          `}
        ></rect>
        <g filter="url(#filter0_f_2755_7146)">
          {/* loop and animation add first as final*/}
          <motion.path
            d="M 1246.697 -42.712 C 1246.697 43.601 1182.131 114.018 1101.975 114.018 C 1021.818 114.018 957.252 43.601 957.252 -42.712 C 957.252 -129.025 1021.818 -199.441 1101.975 -199.441 C 1182.131 -199.441 1246.697 -129.025 1246.697 -42.712 Z"
            stroke="black"
            stroke-width="71.18"
            initial={PathVariants.mid}
            animate={PathVariants.start}
            exit={PathVariants.start}
            transition={{
              duration: 10,
              ease: "easeInOut",
              repeat: Infinity,
              repeatType: "reverse",
            }}
          ></motion.path>
          <motion.circle
            cx="737.173"
            cy="76.173"
            r="76.173"
            fill="black"
            initial={circle1Varients.mid}
            animate={circle1Varients.start}
            exit={circle1Varients.start}
            transition={{
              duration: 10,
              ease: "easeInOut",
              repeat: Infinity,
              repeatType: "reverse",
            }}
            css={css`
              pointer-events: none;
            `}
          ></motion.circle>
          <motion.circle
            cx="887.576"
            cy="283.353"
            r="102.445"
            fill="black"
            initial={circle2Varients.mid}
            animate={circle2Varients.start}
            exit={circle2Varients.start}
            transition={{
              duration: 10,
              ease: "easeInOut",
              repeat: Infinity,
              repeatType: "reverse",
            }}
            css={css`
              pointer-events: none;
            `}
          ></motion.circle>
          <motion.circle
            cx="1238.16"
            cy="227.198"
            r="63.7318"
            transform="rotate(95.7089 1238.16 227.198)"
            // initial={circle3Varients.mid}
            // animate={circle3Varients.start}
            // exit={circle3Varients.start}
            // transition={{
            //   duration: 10,
            //   ease: "easeInOut",
            //   repeat: Infinity,
            //   repeatType: "reverse",
            // }}
            fill="black"
          ></motion.circle>
          <motion.circle
            cx="1096.95"
            cy="-32.0508"
            r="317.24"
            stroke="black"
            stroke-width="100"
            id={"4"}
            initial={circle4Varients.mid}
            animate={circle4Varients.start}
            exit={circle4Varients.start}
            transition={{
              duration: 10,
              ease: "easeInOut",
              repeat: Infinity,
              repeatType: "reverse",
            }}
            css={css`
              pointer-events: none;
            `}
          ></motion.circle>
          <motion.circle
            cx="1225.48"
            cy="164.165"
            r="63.7318"
            transform="rotate(95.7089 1225.48 164.165)"
            fill="black"
            // id={"5"}
            // initial={circle5Varients.mid}
            // animate={circle5Varients.start}
            // exit={circle5Varients.start}
            // transition={{
            //   duration: 10,
            //   ease: "easeInOut",
            //   repeat: Infinity,
            //   repeatType: "reverse",
            // }}
            css={css`
              pointer-events: none;
            `}
          ></motion.circle>
          <g
            css={css`
              mix-blend-mode: exclusion;
              pointer-events: none;
            `}
          >
            <circle
              cx="79.2152"
              cy="79.2152"
              r="42.5"
              stroke="#AEAEAE"
              stroke-width="73.4304"
            ></circle>
          </g>
        </g>
        <g
          css={css`
            mix-blend-mode: color-dodge;
            pointer-events: none;
          `}
        >
          <rect width="1440" height="1440" fill="#878787"></rect>
        </g>
        <g
          css={css`
            mix-blend-mode: color-burn;
            pointer-events: none;
          `}
        >
          <rect width="1440" height="1440" fill="black"></rect>
        </g>
        <g
          css={css`
            mix-blend-mode: screen;
            pointer-events: none;
          `}
          transform="matrix(1, 0, 0, 1, 57, 0)"
        >
          <rect
            width="1440"
            height="1440"
            transform="translate(0 -0.00195312)"
            fill="#FFD550"
          ></rect>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_2755_7146"
          x="574.871"
          y="-528"
          width="1018.03"
          height="1114"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          ></feBlend>
          <feGaussianBlur
            stdDeviation="47"
            result="effect1_foregroundBlur_2755_7146"
          ></feGaussianBlur>
        </filter>
        <clipPath id="clip0_2755_7146">
          <rect width="1440" height="900" fill="white"></rect>
        </clipPath>
      </defs>
    </svg>
  );
};

function HeroAnimation() {
  return (
    <div
      css={css`
        top: 0;
        left: 0;
        right: 0;
        z-index: -1;
        position: absolute;
        width: 100%;
        display: flex;
        justify-content: end;

        @media (max-width: ${MOBILE}px) {
          display: none;
        }
      `}
    >
      <Edited />
    </div>
  );
}

export default HeroAnimation;
